import styled from "styled-components";
import media from "constants/media";
import ScrollContainer from "react-indiana-drag-scroll";

export const CategoriesMobile = styled.div`
    width: 92%;
    margin: 24px 0 0 10px;
    overflow: hidden;

    ${media.mdUp`
        display: none;
    `}
`;

export const Title = styled.h2`
    margin-bottom: 26px;

    font-weight: normal;
    font-size: 20px;
    line-height: 25px;
`;

export const Items = styled(ScrollContainer)`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    height: 34px;

    margin: 0;

    list-style: none;
    cursor: grab;
`;

export const Item = styled.li`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 30px;
    margin-right: 10px;
    padding: 0 10px;

    font-size: 14px;
    line-height: 20px;
    white-space: nowrap;

    background: var(--color-athensGrey);
    border: 1px solid rgba(0, 23, 75, 0.1);

    transition: 0.2s all ease-in-out;

    &:active,
    &:focus,
    &:target {
        color: var(--color-white);

        background: var(--color-peach);
        box-shadow: 2px 2px 0 0 var(--color-purple);
    }

    ${({ active }) =>
        active &&
        `
        color: var(--color-white);

        background: var(--color-peach);
        box-shadow: 2px 2px 0 0 var(--color-purple);`}
`;
